import {Component, NgZone, OnInit} from '@angular/core';
import {Account} from '../../shared/models/account';
import {SessionService} from '../../core/service/session.service';
import {CommonService} from '../../core/service/common.service';
import {ResizeService} from '../../core/service/resize.service';
import {MainWindowComponent} from '../../core/main-window/main-window.component';

@Component({
  selector: 'app-first',
  templateUrl: './first.component.html',
  styleUrls: ['./first.component.scss'],
})
export class FirstComponent implements OnInit {
  show = false;
  loading = false;
  public account = new Account(); // 追加

  constructor(private sessionService: SessionService,
              private commonService: CommonService,) {
    this.account.email = commonService.getParamValueQueryString('email') ?? '';
  }

  /**
   *
   */
  ngOnInit(): void {
  }
  /**
   *
   * @param e
   */
  submitLogin(e: Event): void {
    e.preventDefault();
    this.account.password = this.account.email;
    this.sessionService.loginWithEmailAndPassword(this.account);
    this.loading = true;
  }
}
